import { Type } from "../type";
export const productsLoadingMutations = {
  [Type.PRODUCT_LOADING_START](state) {
    state.loading = true;
  },
  [Type.PRODUCT_LOADING_DONE](state) {
    state.loading = false;
  },
};
